import trackInMatomo, { TrackEvent } from './Matomo/MatomoEvent';

export type GenericTrackData = TrackEvent & GATrackEvent;
export type iFixitTrackingData = Omit<GenericTrackData, 'eventName'> &
   Partial<Pick<GenericTrackData, 'eventName'>>;

export type GATrackEvent = {
   /**
    * Describes the type of events you want to track.
    * For example, Link Clicks, Videos, Outbound Links, and Form Events.
    */
   eventCategory: string;
   /**
    * The specific action that is taken.
    * For example, with a Video category, you might have a Play, Pause and Complete action.
    */
   eventAction: string;
   /**
    * Usually the title of the element that is being interacted with, to aid with analysis.
    * For example, it could be the name of a Video that was played or the specific
    * form that is being submitted.
    */
   eventName: string;
};

/**
 * @param trackData trackData.eventName will default to the page path if not provided
 */
const trackInMatomoAndGA = (trackData: iFixitTrackingData) => {
   const dataWithEventName = {
      ...trackData,
      eventName: trackData.eventName || `${window.location.origin}${window.location.pathname}`,
   };

   trackInMatomo(dataWithEventName);
   // @ts-ignore
   const site = App.which;
   if (window.ga && site) {
      window.ga(
         `${site}.send`,
         'event',
         dataWithEventName.eventCategory,
         dataWithEventName.eventAction,
         dataWithEventName.eventName
      );
   }
};

const trackLinkInMatomoAndGA = (link: HTMLElement, trackData: iFixitTrackingData) => {
   link.addEventListener('click', event => {
      event.preventDefault();
      trackInMatomoAndGA(trackData);
      const url = link.getAttribute('href');
      if (url) {
         setTimeout(() => (document.location.href = url), 500);
      }
   });
};

export default trackInMatomoAndGA;
export { trackLinkInMatomoAndGA };
